import { useStationFavorites } from '@app/core/stations/hooks/useStationFavorites';
import { StationStatusListItem } from '@app/modules/logger/screens/status/types';
import { partition } from 'lodash';
import { useMemo } from 'react';

export type SortedStatuses = {
  favorites: StationStatusListItem[];
  nonFavorites: StationStatusListItem[];
};

/**
 * Hook that partitions statuses into favorites and non-favorites.
 * Maintains the original order within each group.
 */
export function useSortedStatuses(statuses: StationStatusListItem[]): SortedStatuses {
  const { favoriteIds } = useStationFavorites();

  return useMemo(() => {
    const [favorites, nonFavorites] = partition(statuses, (item) =>
      favoriteIds.includes(item.station.id),
    );

    return { favorites, nonFavorites };
  }, [statuses, favoriteIds]);
}
